// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag[data-v-243a969c] {\n  font-size: 0.75rem;\n  font-weight: var(--magic-font-weight-semibold, 600);\n  height: 24px;\n  background: #b4e2ff;\n  padding: 0 calc(16px - 4px);\n}\n.tag--new[data-v-243a969c] {\n  background: #32d917;\n}\n.tag--hot[data-v-243a969c] {\n  background: #ff6e14;\n}", ""]);
// Exports
module.exports = exports;
